import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

export type Phase = { label: string; date?: string; state: "done" | "current" | "upcoming" };

/** Pozioma oś faz wydarzenia (Zapisy → Głosowanie → Wyniki) z podświetleniem bieżącej. */
export const PhaseTimeline: React.FC<{ phases: Phase[] }> = ({ phases }) => (
  <Box bg="white" borderRadius="20px" boxShadow="0 8px 24px rgba(67,0,152,0.06)" p={{ base: "20px 18px", md: "24px 26px" }}>
    <Flex align="flex-start" position="relative">
      {phases.map((p, i) => {
        const active = p.state !== "upcoming";
        return (
          <Flex key={i} flex="1" direction="column" align="center" position="relative">
            {/* łącznik do następnej fazy */}
            {i < phases.length - 1 && (
              <Box position="absolute" top="13px" left="50%" right="-50%" h="2px" bg={phases[i + 1].state !== "upcoming" ? "primary" : "rgba(67,0,152,0.12)"} />
            )}
            <Flex
              w="26px"
              h="26px"
              borderRadius="full"
              align="center"
              justify="center"
              zIndex={1}
              bg={active ? "primary" : "white"}
              border="2px solid"
              borderColor={active ? "primary" : "rgba(67,0,152,0.18)"}
              boxShadow={p.state === "current" ? "0 0 0 5px rgba(67,0,152,0.12)" : undefined}
            >
              {p.state === "done" ? (
                <Box w="9px" h="9px" borderRadius="full" bg="white" />
              ) : p.state === "current" ? (
                <Box w="8px" h="8px" borderRadius="full" bg="white" />
              ) : null}
            </Flex>
            <Text mt="9px" fontSize="13px" fontWeight={p.state === "current" ? "800" : "700"} color={active ? "primary" : "gray.400"} textAlign="center">
              {p.label}
            </Text>
            {p.date && (
              <Text fontSize="11.5px" color="gray.400" textAlign="center" mt="1px">
                {p.date}
              </Text>
            )}
          </Flex>
        );
      })}
    </Flex>
  </Box>
);
